import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-limit.ts';

const modelValueType: Record<TModelValueType, string> = {
  auto: 'Auto',
  value: 'Statisch',
  factoredLimit: 'Dynamisch',
};

export default {
  modelValueType,
};
